import {List} from 'immutable';

export const CREATE_RELOCATION_OPTION2_VERICATION = 
  {
    "Reason for change": [],
    "Transferee's Posting Worn Rank": [],
    "Departing Base": {},
    "Departing Date": {},
    "Arriving Base": {},
    "Arriving Date": {}
  }
;
//export const BASICURL = "https://tolltwsuatproxy.azurewebsites.net/";

export const CALENDARARRAY_RELOCATION = List([
      "Planned Out Calendar",
      "Promulgation Date Calendar",
      'Departing Base_2 Calendar',
      'Departing Base_3 Calendar',
      'Effective Date Calendar',
      'Arriving Date Calendar'
])
export const INITIAL_CALENDAR_STATE ={
  "Promulgation Date Calendar": false,
  "Departing Base_2 Calendar": false,
  "Departing Base_3 Calendar": false,
  "Effective Date Calendar": false,
  "Arriving Date Calendar": false,
  "Planned Out Calendar": false,
}
export const RELOCATION_API_URL=[
  //"Service Types"                     JSON_Index:0
  {post:'api/CaseDetailService/RetrieveClientServiceTypes'},
  //"Worn Rank Types"                   JSON_Index:1
  {get: 'api/ReferenceDataService/RetrieveWornRankTypes'},
  // "Family types"                     JSON_Index:2
  {get: 'api/ReferenceDataService/RetrieveFamilyTypes'},
  // 'Function types'                   JSON_Index:3
  {get: 'api/ReferenceDataService/RetrieveFunctionTypes'},
  // 'Sub Function types'               JSON_Index:4
  {get: 'api/ReferenceDataService/RetrieveSubFunctionTypes'},
  // 'Position Description types'       JSON_Index:5
  {get: 'api/ReferenceDataService/RetrievePositionDescriptionTypes'},
  // 'Work Group types'                 JSON_Index:6
  {get: 'api/ReferenceDataService/RetrieveWorkGroupTypes'},
  // 'Unit types'                       JSON_Index:7
  {get: 'api/ReferenceDataService/RetrieveUnitTypes'},
  // 'Reason for Posting id:null 2' 'Reason for change id:null 1' JSON_Index:8 ,9
  {post:'api/ReferenceDataService/RetrieveReasonForRelocationSubTypes'},
  // {post:'/api/ClientDetailService/RetrieveClientReasonForRelocationDetails'},
  // 'Duration of Posting'              JSON_Index:10
  {get :"api/ReferenceDataService/RetrievePostingTenureTypesByClient"},
  // Transferee's Posting Worn Rank     JSON_Index:11
  {get:'api/ReferenceDataService/RetrieveTitlesById'},
  // Departing Base && Arriving Base    JSON_Index:12
  {get:'api/ReferenceDataService/RetrieveLocalities'}
]
export const CREATE_CASE_URI = 'api/Case/Fixed/Defence';

// Button
export const GLOBAL_BTN_ADD = "Add";
export const GLOBAL_BTN_BACK = "Back";
export const GLOBAL_BTN_NEXT = "Next";
export const GLOBAL_BTN_EDIT = "Edit";
export const GLOBAL_BTN_DELETE = "Delete";
export const GLOBAL_BTN_SEARCH = "Search";
export const GLOBAL_BTN_GO = "Go";
export const GLOBAL_BTN_LOGIN = "Log In";
export const GLOBAL_BTN_SIGNUP = "Sign Up";
export const GLOBAL_BTN_SUBMIT = "Submit";
export const GLOBAL_BTN_CREATE = "Create";
export const GLOBAL_BTN_CANCEL = "Cancel";
export const GLOBAL_BTN_CRNEIN = "Create New Inventory";
export const GLOBAL_BTN_EDITSEL = "Edit Selected Inventory";
export const GLOBAL_BTN_CHINPECI = "Change in Personal Circumstances";
export const GLOBAL_BTN_CHINPECI_NB = "New relocation"
export const GLOBAL_BTN_CRRE = "Create Relocation";
export const GLOBAL_BTN_CRRE_NB = 'Activation';
export const GLOBAL_BTN_CRREIN = "Create New Inventory";
export const GLOBAL_BTN_INRE = "International Relocation";
export const GLOBAL_BTN_APFOREE = "Application for Relocation";
export const GLOBAL_BTN_MOPLLE = "Move Plan Letter";
export const GLOBAL_BTN_MOPLLE_NB = "Relocation Confirmation Letter"
export const GLOBAL_BTN_SUBMIT_NOTICE = "Submit Notice";

//Footer
export const GLOBAL_FOOTER1 = "Privacy policy";
export const GLOBAL_FOOTER2 = "Need Assistance? Freecall 1800 819 167";
export const GLOBAL_FOOTER3 = "Copyright ©  Toll Transitions. All Rights Reserved";
export const GLOBAL_FOOTER4 = "Ver 02.19.03";

//Header
export const GLOBAL_HEADER1 = "Transferee Website";
export const GLOBAL_HEADER2 = "Welcome:";
export const GLOBAL_HEADER3 = "Log Out";
export const GLOBAL_HEADER4 = "Welcome to Toll Transitions Transferee Website";
export const GLOBAL_HEADER5 = "Welcome to TOLL Transferee Website";

//LoginForm
export const GLOBAL_LOGINFORM1 = "Login";
export const GLOBAL_LOGINFORM2 = "Username";
export const GLOBAL_LOGINFORM3 = "Username is required.";
export const GLOBAL_LOGINFORM4 = "Password";
export const GLOBAL_LOGINFORM5 = "Password is required.";
export const GLOBAL_LOGINFORM6 = "IMPORTANT: The combination of Username and Password is invalid.";
export const GLOBAL_LOGINFORM7 = "Forgotten my password";
export const GLOBAL_LOGINFORM8 = "Don't have an account?";
export const GLOBAL_LOGINFORM9 = "Forgotten my login";
//MyHomePage
export const GLOBAL_MYHOMEPAGE1 = "My Home Page";
export const GLOBAL_MYHOMEPAGE2 = "Relocation";
export const GLOBAL_MYHOMEPAGE3 = "Inventory";
export const GLOBAL_MYHOMEPAGE4 = "Forms and Guides";
export const GLOBAL_MYHOMEPAGE5 = "My Contact Details";
export const GLOBAL_MYHOMEPAGE6 = "Change Password";
//MyHomePage step
export const GLOBAL_CREATE_RELOACLTION = "Create Relocation";
export const GLOBAL_CREATE_RELOACLTION_NB = "Activation";
export const GLOBAL_APPLICATION_FOR_RELOACLTION = "Application for Relocation";
export const GLOBAL_APPLICATION_FOR_RELOACLTION_NB = "Relocation Request";
export const GLOBAL_MOVE_PLAN_LATTER = "Move Plan Letter";
export const GLOBAL_MOVE_PLAN_LATTER_NB = "Relocation Confirmation Letter";

//MyHomePage table 
export const GLOBAL_RERE = "Request Reimbursement";
export const GLOBAL_TABLE_TR1 = "Case Number";
export const GLOBAL_TABLE_TR2 = "Order No.";
export const GLOBAL_TABLE_TR3 = "Inventory";
export const GLOBAL_TABLE_TR4 = "From";
export const GLOBAL_TABLE_TR5 = "To";
export const GLOBAL_TABLE_TR6 = "Case Manager";
export const GLOBAL_TABLE_TR7 = "Status";
export const GLOBAL_TABLE_TR8 = "Action";
export const GLOBAL_TABLE_TR9 = "Completed";

// request type 
export const REQUEST_TYPE_GET = "GET";
export const REQUEST_TYPE_POST = "POST";

// 
export const GLOBAL_BTN_CLOSE = "Close";
export const GLOBAL_BTN_SUBMITREQUEST = "Submit Reimbursement Request";

// inventory
export const GLOBAL_BTN_BACK_TO_INVENTORY = 'Back To Inventory';
export const GLOBAL_BTN_RESET = 'Reset';
export const GLOBAL_BTN_UPDATE = 'Update';

// relocation
export const GLOBAL_BTN_PREVIOUS = 'Previous';
export const GLOBAL_BTN_SAVE_CLOSE = 'Save & Close';

export const BTN_LARGE_SIZE = "large";
export const BTN_NORMAL_SIZE = "normal";
export const BTN_SMALL_SIZE = "small";

// The size of all buttons
export const BTN_SIZE = {
  [BTN_LARGE_SIZE]: "button_large",
  [BTN_NORMAL_SIZE]: "button_normal",
  [BTN_SMALL_SIZE]: "button_small"
};
// Inventory Details (Relocation Request)
export const SITEDETAILS = [
  '>20m walk',
  '2 storeys',
  'Ferry vehicles',
  'Ground floor good access',
  'Highrise complex',
  'Lift access available',
  'Low power lines',
  'No driveway access',
  'No parking on driveway',
  'Other',
  'Parking available on street',
  'Parking restrictions in front of house',
  'Rear access available',
  'Stair access',
  'Steep narrow driveway',
  'Steep narrow stairs'
]
//RelocationBookmark navigate step 
export const RelocationBookmark = {
  
  "Introduction" : 1,
  "Personal" : 2, //Personal Details
  "RelocationDetails" : 4, // Relocation Details
  "Dependants"  : 4,
  "HousingConsideration" : 5,
  "PetDetails" : 6,
  "Travel"  : 9, //7,
   //Logistics = 9,
  "Accommodation"  : 10,
  "OtherConsiderations"  : 11,
  "Removal" : 13,
  "Itinerary"  : 13,
  "Authorisation"  : 14,
  "Declaration"  : 15,
  "SubmitAFR"  : 16
}
export const ENTITYNAME =  'CASE';
export const CATEGORY = '39';
export const COUNTRYID_AUSTRALIA = 13;
export const COUNTRYID_USA = 242;

